export const CAMPAIGN_SETTING_TAG = 'CampaignSetting';

export const TAGS = [CAMPAIGN_SETTING_TAG];
